import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import { fontSizes } from "healthex-common/sizes";
import styled from "styled-components";
import blockchainIcon from "../Media/blockchain-icon.png";
import { HXButton } from "./HXButton";
import { srcAttr } from "./base.styles";
export const BlockchainDialog = styled(Dialog) `
    & .MuiDialog-paper {
        width: 500px;
        max-width: 500px;

        font-size: ${fontSizes.SMALL};
    }

    & .MuiDialogTitle-root {
    }

    & .MuiDialogContent-root {
        padding: 15px 20px;
    }
`;
export const BlockchainSpinnerWrapper = styled.div `
    margin: 0 auto;
    width: 80px;
    position: relative;
    margin-bottom: 20px;
`;
export const BlockchainSpinner = styled(CircularProgress) `
    width: 80px !important;
    height: 80px !important;
`;
export const BlockchainSpinnerImage = styled.img.attrs(srcAttr(blockchainIcon)) `
    position: absolute;
    top: 20px;
    left: 15px;
    width: 50px;
`;
export const BlockchainDialogText = styled.div `
    text-align: center;
`;
export const BlockchainExplanationText = styled.div `
    text-align: center;
    margin-top: 20px;
`;
export const BlockchainLearnMoreButton = styled(HXButton) ``;
